import { render } from "./addtional_report_public.vue?vue&type=template&id=5e254164&scoped=true"
import script from "./addtional_report_public.vue?vue&type=script&lang=js"
export * from "./addtional_report_public.vue?vue&type=script&lang=js"

import "./addtional_report_public.vue?vue&type=style&index=0&id=5e254164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e254164"]])

export default __exports__